import { CommonModule } from '@angular/common'
import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
  standalone: true,
  imports: [OptimUiSharedModule, CommonModule, RouterLink, FontAwesomeModule],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() navbarBrandRouterLink: any[] = []
  @Input() navbarBrandFull: any = {}
  @Input() navbarBrandMinimized: any = {}
  @Input() fixed: boolean = false
  @Input() sidebarToggler: string = ''
  @Input() asideMenuToggler: any = false
  @Output() sidebarToggled = new EventEmitter<void>()
  @Output() asideToggled = new EventEmitter<void>()

  constructor(private router: Router) {}

  ngOnInit() {}

  toggleSidebar() {
    this.sidebarToggled.emit()
  }

  toggleAside() {
    this.asideToggled.emit()
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Prevent dropdown auto-close for ngx-bootstrap
  }
}
